/* hgn-kit-claim.js — "Email me my kit" (kit-leak build 2, 2026-10-11;
   redesigned/KIT-LEAK-BRIEF-2026-10-11.md, KIT-BUILD.md §11p).

   Only 46 of the 378 UK kits left in a bag (30 Sep – 11 Oct) belonged to an
   email we knew, so the Kit Ready flow (UKeCQ9, trigger Completed Starter
   Kit) could reach almost none of them. Under a saved kit in the side cart,
   a shopper we can't identify gets one small card: email in, tap, and the
   popup worker's POST /api/kit/claim attaches the email to this device's kit
   row with marketing consent and starts Kit Ready for them
   (popup-v1/PATCH-kitclaim-v103-2026-10-11.md).

   Rendered by assets/hgn-side-cart.js (renderer hook under the bundle
   cards); this file owns eligibility, the arm, the submit and the copy.

   Arm family `kitclaim` (setting "Email me my kit arm" in the announcement
   bar → HGN_SIDE_CART_CONFIG.attach.kitClaimArm). Ships `off` — no card for
   anyone — until the worker's kitClaim switch is on; then the 80% test.
   A = no card. B = the card. `kitclaim_eligible` fires in BOTH arms at the
   same moment (a saved kit in the drawer + an unidentified shopper), so the
   readout compares like with like.

   Not shown when: signed in (HGN_CUSTOMER_ID), the popup already has the
   email (hgn-popup:state.subscribed), Klaviyo already knows the browser
   (__kla_id carries $email / $exchange_id), this device already claimed,
   the card was dismissed in the last 7 days, or the market isn't GB. */
(function () {
  'use strict';
  window.HGN = window.HGN || {};
  if (window.HGN.kitClaim) return;

  var ENDPOINT = 'https://popup.holygrailnail.co/api/kit/claim';
  var CONSENT_VERSION = 'kit-claim-v1-2026-10';
  var MARKETS = ['GB'];
  var DONE_KEY = 'hgn_kit_claim';          /* localStorage: claimed on this device */
  var SENT_KEY = 'hgn_kit_claim_sent';     /* sessionStorage: show the thank-you this session */
  var HIDE_KEY = 'hgn_kit_claim_hide';     /* localStorage: dismissed until (ms) */
  var HIDE_MS = 7 * 24 * 60 * 60 * 1000;

  /* Copy approved by Matt in chat, 16 Oct 2026. */
  var COPY = {
    title:   'Email me my kit',
    sub:     'Not checking out yet? We’ll email your kit so you can pick it up on any device.',
    field:   'Your email',
    button:  'Email me my kit',
    busy:    'Sending…',
    legal:   'By tapping you agree to receive emails from Holy Grail Nail, including your kit and offers. Unsubscribe any time — see our <a href="/policies/privacy-policy">privacy policy</a>.',
    sent:    'Saved — your kit is on its way to {email}.',
    invalid: 'Please check your email address.',
    failed:  'Sorry, that didn’t send. Please try again.',
    close:   'Not now'
  };

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function offer(name, detail) {
    try { document.dispatchEvent(new CustomEvent('hgn:offer:' + name, { detail: detail || {} })); } catch (e) {}
  }

  var registered = false;
  /* Off = the feature isn't launched: no card AND no exposure rows, so the
     readout's arm A starts the day the test does (the registry itself
     answers 'A' for `off`). A QA pin (?hgn_kitclaim=A|B) still shows it. */
  function switchedOff() {
    var qa = null;
    try { qa = sessionStorage.getItem('hgn_arm_qa_kitclaim'); } catch (e) {}
    if (qa === 'A' || qa === 'B') return false;
    try {
      var v = window.HGN_SIDE_CART_CONFIG && window.HGN_SIDE_CART_CONFIG.attach && window.HGN_SIDE_CART_CONFIG.attach.kitClaimArm;
      return v == null || v === '' || String(v) === 'off';
    } catch (e) { return true; }
  }
  function arm() {
    if (!registered && typeof window.HGN.registerArm === 'function') {
      window.HGN.registerArm('kitclaim', 'kitClaimArm', { pctB: 80, qa: 'hgn_kitclaim' });
      registered = true;
    }
    return registered && typeof window.HGN.armFor === 'function' ? window.HGN.armFor('kitclaim') : null;
  }

  function market() {
    try { return String((window.Shopify && window.Shopify.country) || '').toUpperCase(); } catch (e) { return ''; }
  }
  function klaviyoKnows() {
    try {
      var m = /(?:^|;\s*)__kla_id=([^;]+)/.exec(document.cookie || '');
      if (!m) return false;
      var o = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(o && (o.$email || o.$exchange_id));
    } catch (e) { return false; }
  }
  function popupKnows() {
    try { var st = JSON.parse(lsGet('hgn-popup:state') || '{}'); return !!(st && st.subscribed); } catch (e) { return false; }
  }
  function identified() {
    return !!window.HGN_CUSTOMER_ID || popupKnows() || klaviyoKnows();
  }
  function hidden() {
    var until = parseInt(lsGet(HIDE_KEY), 10);
    return isFinite(until) && until > Date.now();
  }

  /* The kit this card speaks for: the first saved kit with a target price
     (a real finalised kit, not a legacy bundle). */
  function kitOf(bundles) {
    for (var i = 0; i < (bundles || []).length; i++) {
      var b = bundles[i];
      if (b && b.tier && b.gbpPaidCents != null) return b;
    }
    return null;
  }

  var eligibleLogged = {};
  var kitCache = {};
  function markup(bundles) {
    var kit = kitOf(bundles);
    if (!kit) return '';
    kitCache[kit.id] = kit;
    if (MARKETS.indexOf(market()) === -1) return '';
    var sentEmail = ssGet(SENT_KEY);
    if (sentEmail) {
      return '<div class="hgn-kit-claim hgn-kit-claim--sent" data-hgn-kit-claim>' +
        '<p class="hgn-kit-claim__msg" role="status">' + esc(COPY.sent.replace('{email}', sentEmail)) + '</p>' +
      '</div>';
    }
    if (lsGet(DONE_KEY) || identified() || hidden()) return '';
    var a = arm();
    if (switchedOff()) return '';
    if (a !== 'A' && a !== 'B') return '';
    if (!eligibleLogged[kit.tier]) {
      eligibleLogged[kit.tier] = true;
      offer('kitclaim_eligible', { tier: kit.tier });
    }
    if (a !== 'B') return '';
    offer('kitclaim_shown', { tier: kit.tier });
    return '<div class="hgn-kit-claim" data-hgn-kit-claim data-tier="' + esc(kit.tier) + '" data-bundle="' + esc(kit.id) + '">' +
      '<button type="button" class="hgn-kit-claim__close" data-hgn-kit-claim-close aria-label="' + esc(COPY.close) + '">' +
        '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<p class="hgn-kit-claim__title">' + esc(COPY.title) + '</p>' +
      '<p class="hgn-kit-claim__sub">' + esc(COPY.sub) + '</p>' +
      '<form class="hgn-kit-claim__form" data-hgn-kit-claim-form novalidate>' +
        '<input class="hgn-kit-claim__input" type="email" name="email" autocomplete="email" inputmode="email" placeholder="' + esc(COPY.field) + '" aria-label="' + esc(COPY.field) + '" required>' +
        '<input class="hgn-kit-claim__hp" type="text" name="hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<button class="hgn-kit-claim__btn" type="submit">' + esc(COPY.button) + '</button>' +
      '</form>' +
      '<p class="hgn-kit-claim__legal">' + COPY.legal + '</p>' +
      '<p class="hgn-kit-claim__msg" data-hgn-kit-claim-msg role="status" aria-live="polite"></p>' +
    '</div>';
  }

  /* Kit snapshot for a device with no kit row (analytics declined → no
     hgn:did → the beacon never ran): the worker creates the row from this. */
  function snapOf(bundleId) {
    try {
      var kit = kitCache[bundleId];
      var items = (kit && kit.items) || [];
      if (!items.length) return null;
      var p0 = items[0].properties || {};
      var tier = kit.tier;
      var acc = (window.HGN_KIT_ACCESSORIES || {})[tier] || {};
      var accHandles = {};
      Object.keys(acc).forEach(function (s) { (acc[s] || []).forEach(function (o) { if (o && o.handle) accHandles[o.handle] = 1; }); });
      var picks = items.filter(function (it) { return !accHandles[it.handle]; }).map(function (it) {
        return { handle: it.handle, title: it.product_title || it.title || '', image: it.image || '' };
      });
      return {
        tier: tier, state: 'completed', stepsDone: 1, stepsTotal: 1, missing: [], picks: picks,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
        kitPriceCents: parseInt(p0._bundle_price_gbp_cents, 10) || 0
      };
    } catch (e) { return null; }
  }

  function setMsg(root, text, isError) {
    var el = root.querySelector('[data-hgn-kit-claim-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', !!isError);
  }

  function submit(form) {
    var root = form.closest('[data-hgn-kit-claim]');
    if (!root || root.getAttribute('data-busy') === '1') return;
    var input = form.querySelector('input[name="email"]');
    var email = String((input && input.value) || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { setMsg(root, COPY.invalid, true); if (input) input.focus(); return; }
    var tier = root.getAttribute('data-tier') || '';
    var bundleId = root.getAttribute('data-bundle') || '';
    var btn = form.querySelector('button[type="submit"]');
    root.setAttribute('data-busy', '1');
    if (btn) { btn.disabled = true; btn.textContent = COPY.busy; }
    setMsg(root, '');
    /* Read the device before any offer event: the arm beacon mints an
       hgn:did on its first event if none exists, which would hand the
       worker a device with no kit row. */
    var did = lsGet('hgn:did') || '';
    offer('kitclaim_submit', { tier: tier });
    var cid;
    try {
      var cm = /(?:^|;\s*)_hgn_cid=([A-Za-z0-9_.\-]+)/.exec(document.cookie || '');
      if (cm && cm[1].length >= 8 && cm[1].length <= 64) cid = cm[1];
    } catch (e) {}
    var hp = form.querySelector('input[name="hp"]');
    var body = JSON.stringify({
      did: did, cid: cid, email: email, consent: true, consentVersion: CONSENT_VERSION,
      tier: tier, page: location.pathname, hp: (hp && hp.value) || '',
      /* Always sent: the worker uses it only when its own row for this
         device isn't a fresh completed kit (no did, a late beacon). */
      snap: snapOf(bundleId)
    });
    /* text/plain, like the kit beacon: a simple request, no CORS preflight. */
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body, keepalive: true })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j || {} }; }); })
      .then(function (res) {
        if (res.ok && res.j && res.j.ok) {
          lsSet(DONE_KEY, JSON.stringify({ at: Date.now(), tier: tier }));
          /* The popup stops showing on its own client flag; the worker says
             whether to set it (cfg.kitClaim.suppressPopup). */
          if (res.j.suppressPopup) {
            try {
              var st = JSON.parse(lsGet('hgn-popup:state') || '{}') || {};
              st.subscribed = true;
              if (!st.email) st.email = email;
              st.timestamp = Date.now();
              lsSet('hgn-popup:state', JSON.stringify(st));
            } catch (eSt) {}
          }
          ssSet(SENT_KEY, email);
          offer('kitclaim_sent', { tier: tier, reason: res.j.status || '' });
          root.classList.add('hgn-kit-claim--sent');
          root.innerHTML = '<p class="hgn-kit-claim__msg" role="status">' + esc(COPY.sent.replace('{email}', email)) + '</p>';
          return;
        }
        throw new Error((res.j && res.j.reason) || 'claim-failed');
      })
      .catch(function () {
        root.removeAttribute('data-busy');
        if (btn) { btn.disabled = false; btn.textContent = COPY.button; }
        setMsg(root, COPY.failed, true);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-hgn-kit-claim-form]');
    if (!form) return;
    e.preventDefault();
    submit(form);
  }, true);
  document.addEventListener('click', function (e) {
    var x = e.target && e.target.closest && e.target.closest('[data-hgn-kit-claim-close]');
    if (!x) return;
    e.preventDefault();
    var root = x.closest('[data-hgn-kit-claim]');
    lsSet(HIDE_KEY, String(Date.now() + HIDE_MS));
    offer('kitclaim_dismissed', { tier: (root && root.getAttribute('data-tier')) || '' });
    if (root) root.remove();
  }, true);

  /* `off` lets the arm beacon skip this family while it's switched off,
     so no device is logged as arm A before the test starts. */
  window.HGN.kitClaim = { markup: markup, COPY: COPY, off: switchedOff };
})();
